/**
 * Tiempo transcurrido corto, el de las alertas de asignación: «ahora» ·
 * «hace 5 min» · «hace 3 h» · «hace 2 d» (mismos textos que el mockup).
 *
 * No reemplaza a `haceCuanto` de la Bandeja («hace 1 día»), que mide colas de
 * días: aquí importan los minutos, porque la alerta acaba de llegar.
 */
export function haceRelativo(fecha, ahora = Date.now()) {
  const ms = ahora - new Date(fecha).getTime();
  if (!Number.isFinite(ms)) return "";
  const min = Math.floor(ms / 6e4);
  if (min < 1) return "ahora";
  if (min < 60) return `hace ${min} min`;
  const horas = Math.floor(min / 60);
  if (horas < 24) return `hace ${horas} h`;
  return `hace ${Math.floor(horas / 24)} d`;
}
